import React from "react";
import {
  //Avatar, 
  Typography, Box,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions, Button
}
  from "@mui/material";
//import ShareIcon from "@mui/icons-material/Share";
//import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import { useSelector } from "react-redux";
import { fsSmall, pcolor, rcolor } from "../../../style2";

// const useStyles = makeStyles((theme) => ({
//   name: {
//     fontWeight: "bold",
//     fontSize: "22px",
//     color: "#115C71",
//   },
//   icon: {
//     maxWidth: 50,
//     height: 35,
//     background: "rgba(255, 118, 126, 0.1)",
//     borderRadius: 8,
//     color: "#FF767E",
//   },
//   nhs: {

//     fontSize: "18px",
//     color: "#115C71",
//   },
//   diagnosisanddob: {
//     fontSize: 17,
//     color: "#115C71",
//   },
// }));
const name = {
  fontWeight: "bold",
  fontSize: "22px",
  color: pcolor,
};

// const icon = {
//   maxWidth: 50,
//   height: 35,
//   background: "rgba(255, 118, 126, 0.1)",
//   borderRadius: 8,
//   color: "#FF767E",
// };

// const nhs = {
//   fontSize: "18px",
//   color: pcolor,
// };

const diagnosisanddob = {
  fontSize: 17,
  color: pcolor,
};
// const calculateAge = (dob) => {
//   const birthDate = new Date(dob);
//   const today = new Date();
//   let age = today.getFullYear() - birthDate.getFullYear();
//   const monthDifference = today.getMonth() - birthDate.getMonth();

//   if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
//     age--;
//   }
//   return age;
// };
export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();

  if (today.getDate() < birthDate.getDate()) {
    months--;
  }
  if (months < 0) {
    years--;
    months += 12;
  }
  if (years > 0)
    return `${years} y ${months} m`;
  else
    return `${months} m`;
};
function DetailText({ share_icons, diagnosis, gmfcLevel }) {
  //const classes = useStyles();
  const patient = useSelector((state) => state.patient.value);
  const [openDiagnosis, setOpenDiagnosis] = React.useState(false);

  const handleClickOpenDiagnosis = () => {
    setOpenDiagnosis(true);
  };

  const handleCloseDiagnosis = () => {
    setOpenDiagnosis(false);
  };

  const getDiagnosisTitle = () => {
    if (diagnosis === null || diagnosis === undefined)
      return "";
    else if (diagnosis.length === 0)
      return "";
    else {
      return diagnosis[0].title;
    }
  }

  const getDiagnosisCount = () => {
    if (diagnosis === null || diagnosis === undefined)
      return 0;
    else
      return diagnosis.length;

  }

  return (
    <Grid item xs={12} style={{ paddingLeft: 20 }}>
      <Grid container sm spacing={1}>
        <Typography sx={name} >{patient.user.name}</Typography>
      </Grid>
      <Box m={1} />
      <Grid item sm>
        <Typography sx={name}>
          {patient.user.firstName + " " + patient.user.surname + ", "}
          <Typography sx={{ ...name, fontWeight: "normal" }} component="span">{calculateAge(patient.user.dob)}</Typography>
        </Typography>
      </Grid>
      <Grid item sm>
        <Grid container>
          <Grid item xs={12}>
            <Typography sx={diagnosisanddob}>
              {patient.user.nhsNumber}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={diagnosisanddob}>
              {gmfcLevel ? <Box sx={{ color: rcolor, fontSize: "1rem", fontWeight: "bold" }}>GMFCS : Level {gmfcLevel}</Box> : null}
              {getDiagnosisCount() > 0 ? <>
                <Box sx={{ color: pcolor, ...fsSmall }}>Diagnosis:
                  <Chip label={getDiagnosisTitle()} variant="outlined" size="small"
                    onClick={handleClickOpenDiagnosis} clickable={getDiagnosisCount() > 1}
                    sx={{ marginLeft:1, paddingLeft: "0px", maxWidth: "300px", color: pcolor, ...fsSmall }}></Chip>
                </Box>
                {getDiagnosisCount() > 1 ?
                  <Dialog open={openDiagnosis} onClose={handleCloseDiagnosis}
                    aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                      Diagnosis
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <ul>
                          {diagnosis.map(d => <li>{d.title}</li>)}
                        </ul>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDiagnosis}>Ok</Button>

                    </DialogActions>
                  </Dialog> : null}

              </> : null}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default DetailText;
